import { formatDate, formatHours } from '@web/utils';

export function clampPercentage(value: number | null | undefined): number {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 0;
  }
  return Math.max(0, Math.min(100, value));
}

export function formatHoursWithSuffix(
  value: number | null | undefined,
): string {
  return `${formatHours(value)}hrs`;
}

export function formatSignedHoursWithSuffix(
  value: number | null | undefined,
): string {
  const safeValue = typeof value === 'number' ? value : 0;
  const absolute = formatHours(Math.abs(safeValue));
  if (safeValue > 0) {
    return `+${absolute}hrs`;
  }
  if (safeValue < 0) {
    return `-${absolute}hrs`;
  }
  return '0hrs';
}

export function formatRemainingHoursWithSuffix(
  value: number | null | undefined,
): string {
  const safeValue = typeof value === 'number' ? value : 0;
  if (safeValue < 0) {
    return `${formatHours(Math.abs(safeValue))}hrs over`;
  }
  return formatHoursWithSuffix(safeValue);
}

export function formatSignedPercent(value: number | null | undefined): string {
  const safeValue = typeof value === 'number' ? value : 0;
  const rounded = Math.round(safeValue * 10) / 10;
  const digits = Number.isInteger(rounded)
    ? String(rounded)
    : rounded.toFixed(1);
  if (rounded > 0) {
    return `+${digits}%`;
  }
  return `${digits}%`;
}

export function formatDueStatus(
  dueDate: string | null,
  daysToDue: number | null,
): string {
  if (!dueDate) {
    return 'No due date';
  }
  if (daysToDue === null || daysToDue === undefined) {
    return `Due ${formatDate(dueDate, 'MMM D')}`;
  }
  if (daysToDue < 0) {
    return `Due ${Math.abs(daysToDue)}d ago`;
  }
  if (daysToDue === 0) {
    return 'Due today';
  }
  return `Due in ${daysToDue}d`;
}
